import { Controller } from "@hotwired/stimulus"

// Copies provided text to clipboard.
// Usage:
// <span data-controller="clipboard" data-clipboard-text-value="...">
//   <button data-action="click->clipboard#copy">Copy</button>
// </span>
export default class extends Controller {
  static values = { text: String }
  declare textValue: string

  copy() {
    const text = this.textValue || ""
    if (!text) return
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text: string) {
    const el = document.createElement("textarea")
    el.value = text
    el.style.position = "fixed"
    el.style.left = "-9999px"
    document.body.appendChild(el)
    el.focus()
    el.select()
    try { document.execCommand("copy") } catch (_) {}
    document.body.removeChild(el)
  }
}
